






import { Prop, Component, Vue } from "vue-property-decorator";
import { isWeekend } from "date-fns";

@Component
export default class VChartWeekendMask extends Vue {
  @Prop({ default: () => [] }) days!: Date[];

  get cells() {
    return this.days.map(d => (isWeekend(d) ? "weekend" : ""));
  }
}
